// extracted by mini-css-extract-plugin
module.exports = {"container":"e_sv","button":"e_tv","darkModeToggle":"e_uv","icon":"e_vv","buttonText":"e_wv"};